"use strict";

const { getCssPrefix } = require("@runtime/runner/legacy-features");
var PyDefUtils = require("PyDefUtils");

module.exports = function (pyModule) {
    pyModule["DesignLabel"] = Sk.misceval.buildClass(
        pyModule,
        function ($gbl, $loc) {
            $loc["__init__"] = new Sk.builtin.func(
                PyDefUtils.withRawKwargs(function (kwargs, self) {
                    Sk.misceval.call(pyModule["Label"].prototype["__init__"], undefined, undefined, kwargs, self);

                    self._anvil.updateDesignName = updateDesignName;
                })
            );
        },
        "DesignLabel",
        [pyModule["Label"]]
    );

    function updateDesignName(self) {
        let textProp = self._anvil.getPropJS("text"); //'updatedTextProp' in s._anvil ? s._anvil.updatedTextProp : s._anvil.componentSpec.properties['text'];
        let iconProp = self._anvil.getPropJS("icon"); //'updatedIconProp' in s._anvil ? s._anvil.updatedIconProp : s._anvil.componentSpec.properties['icon'];
        let e = self._anvil.element.find(`span.${getCssPrefix()}label-text`);
        e.find(".anvil-designer-empty-component-message").remove();
        if (!self._anvil.inlineEditing && (!textProp || textProp == "") && (!iconProp || iconProp == "")) {
            e.append($('<span class="anvil-designer-empty-component-message">').text(self._anvil.designName));
        }
    }

    const oldTextSet = pyModule["DesignLabel"].prototype._anvilClassic$propMap.text.set;
    const oldIconSet = pyModule["DesignLabel"].prototype._anvilClassic$propMap.icon.set;

    pyModule["DesignLabel"].prototype._anvilClassic$propMap["text"].set = function (s, e, v) {
        oldTextSet(s, e, v);
        updateDesignName(s);
    };

    pyModule["DesignLabel"].prototype._anvilClassic$propMap["icon"].set = function (s, e, v) {
        oldIconSet(s, e, v);
        updateDesignName(s);
    };
};
